BookingApp.controller('BusesController',function($scope,BusService,$routeParams,$uibModal){

    $scope.sortByReturn = function(type){
        if($scope.SortByReturn == type){
            $scope.SortingOrderReturn = (!$scope.SortingOrderReturn);
        }else{
            $scope.SortByReturn = type;
            $scope.SortingOrderReturn = false;
        }
    }

    $scope.sortBy = function(type){
        if($scope.SortBy == type){
            $scope.SortingOrder = (!$scope.SortingOrder);
        }else{
            $scope.SortBy = type;
            $scope.SortingOrder = false;
        }
    }

    //Listen child controller loaded event to fire and set request in it
    $scope.$on('buscontrollerLoaded',function(event,param){
		$scope.$broadcast('set-search-data',$routeParams);
	})

    $scope.SortBy = 'AvailableFares';
    $scope.SortingOrder = true;

    $scope.SortByReturn = 'AvailableFares';
    $scope.SortingOrderReturn = true;
	
	$scope.buses = $scope.$resolve.data.inbond.buses;

    $scope.busesreturn = angular.isDefined($scope.$resolve.data.outbond) ? $scope.$resolve.data.outbond.buses : [];
	
	
	$scope.SessionId = $scope.$resolve.data.inbond.SessionId;
	$scope.SourceName = $scope.$resolve.data.inbond.SourceName;
	$scope.DestinationName = $scope.$resolve.data.inbond.DestinationName;
	$scope.DateOfJourney = $scope.$resolve.data.inbond.DateOfJourney;

    $scope.returnSessionId = angular.isDefined($scope.$resolve.data.outbond) ? $scope.$resolve.data.outbond.SessionId : $scope.$resolve.data.inbond.SessionId;
	

	$scope.init = function (){
        $scope.buses = $scope.$resolve.data.inbond.buses;
        $scope.busesreturn = angular.isDefined($scope.$resolve.data.outbond) ? $scope.$resolve.data.outbond.buses : [];

		$scope.SessionId = $scope.$resolve.data.inbond.SessionId;
		$scope.SourceName = $scope.$resolve.data.inbond.SourceName;
		$scope.DestinationName = $scope.$resolve.data.inbond.DestinationName;
		$scope.DateOfJourney = $scope.$resolve.data.inbond.DateOfJourney;


		//Set Filter Data in Service
		BusService.setFilterData($scope.$resolve.data.inbond.buses,'all');
		
		$scope.Operators = BusService.getOperators();
		$scope.AllBoardingPoints = BusService.getAllBoardingPoints();	
		$scope.BusTypes = BusService.getAllBusType();

		$scope.Filter = {
            OperatorFilter : [],
            TypeFilter      : [],
            IEMFT:false,  //Inbound Only Early Morning Flight Timing
            IMFT:false,   //Inbound Only Moring Flight Timing
            IMDFT:false,  //Inbound Only Mid Day Flight Timing
            INFT:false,    //Inbound Only Night Flight Timing
            Price : {
                mnp:BusService.getPrice('min'),
                mxp:BusService.getPrice('max'),
                options:{
                    floor:BusService.getPrice('min'),
                    ceil:BusService.getPrice('max'),
                    step:1,
                    translate: function(value) {
                        return '<i class="fa fa-rupee"></i> ' + value;
                    }
                }
            }
        }

        if($scope.busesreturn.length){
            BusService.setFilterData($scope.$resolve.data.inbond.buses,'all');
            $scope.ReturnOperators = BusService.getOperators();
            $scope.ReturnAllBoardingPoints = BusService.getAllBoardingPoints();
            $scope.ReturnBusTypes = BusService.getAllBusType();

            $scope.ReturnFilter = {
                OperatorFilter : [],
                TypeFilter      : [],
                DepartureTime : {
                    minTime:0,
                    maxTime:24
                },
                ArrivalTime	: {
                    minTime:0,
                    maxTime:24
                },
                IEMFT:false,  //Inbound Only Early Morning Flight Timing
                IMFT:false,   //Inbound Only Moring Flight Timing
                IMDFT:false,  //Inbound Only Mid Day Flight Timing
                INFT:false,    //Inbound Only Night Flight Timing
                Price : {
                    mnp:BusService.getPrice('min'),
                    mxp:BusService.getPrice('max'),
                    options:{
                        floor:BusService.getPrice('min'),
                        ceil:BusService.getPrice('max'),
                        step:1,
                        translate: function(value) {
                            return '<i class="fa fa-rupee"></i> ' + value;
                        }
                    }
                }
            }
        }



        $("input[type='checkbox']").attr("checked",false);
	}

	$scope.init();

    $scope.toggalFilter = function($filter,$value){
        var index = $scope.Filter[$filter].indexOf($value);
        if(index === -1){
            $scope.Filter[$filter].push($value)
        }else{
            $scope.Filter[$filter].splice(index,1)
        }
    }

    $scope.toggalFilterReturn = function($filter,$value){
        var index = $scope.ReturnFilter[$filter].indexOf($value);
        if(index === -1){
            $scope.ReturnFilter[$filter].push($value)
        }else{
            $scope.ReturnFilter[$filter].splice(index,1)
        }
    }

    $scope.changeTab = function(d){
        $scope.FilterTab = d
    }
	
	$scope.SelectedInBond = false;
    $scope.SelectedOutBond = false;

	//Select seat Modal
	$scope.SelectSeat = function(sid,routeid,type){

        $("body").addClass("modal-open");
        $("body").append("<div class='modal-backdrop fade in' id='temp-backdrop' ><div class='backdrop-loading'></div></div>");

		var SelectSeatInstance = $uibModal.open({
			animation:true,
            ariaLabelledBy: 'select-seat-title',
            ariaDescribedBy: 'select-seat',
            templateUrl: '/buses/' + sid + '/' + routeid,
			size:'lg',
            resolve:{
                'data' : function(BusService){
                    return BusService.getSeatData({'SessionId':sid,RouteId:routeid});
                },
                toSubmit:function(){
                    if(angular.isDefined($scope.$resolve.data.outbond)){
						return false;
					}else{
                        return true;
					}
				},
				sessionId:function(){
					return sid;
				},
				'type':function(){
                	return type;
                }
            },
            controller: 'BusSeatDetailController',
		})

		SelectSeatInstance.result.then(function (data){
			console.log(data);
			if(data.type == 'inbond'){
                $scope.SelectedInBond = data.busData
			}else{
                $scope.SelectedOutBond = data.busData
			}
			console.log($scope.SelectedOutBond);
		},function(data){
		})
	}
	
});